import { Link, useNavigate } from "react-router-dom";
import dataJson from "@/../public/data.json";
import { publicPath, toStagingPath } from "@/utils/base";
import "./index.less";
const tvHeaderPrefix = "header-account";

const HeaderAccount = () => {
  const { header } = dataJson;
  const navigate = useNavigate();

  const clickLogo = () => {
    const atStaging = toStagingPath.some((item) => location.pathname.includes(item));
    navigate(`${atStaging ? publicPath + "staging" : publicPath}`);
  };


  return (
    <div className={tvHeaderPrefix}>
      <div className={`${tvHeaderPrefix}-logo-container`}>
        <div className={`${tvHeaderPrefix}-logo-left`} onClick={() => window.open('https://www.kaihong.com', '_blank')}></div>
        <div className={`${tvHeaderPrefix}-logo-right`} onClick={clickLogo}></div>
        <img
          src={header.logo}
          alt=""
          className={`${tvHeaderPrefix}-logo`}
        />
      </div>
      <div className={`${tvHeaderPrefix}-link`}>
        {header.has_account}
        <Link to={`${publicPath}login`} className="login-link">
          {header.login_now}
        </Link>
      </div>
    </div>
  );
};
export default HeaderAccount;
